import {
    ReportSourceProcedureStatus,
    type ReportPipelineSourceStatus,
} from '@/types/report';
import { SourceStatus } from '@/types/source';

export function shouldShowProcedureStatusRow(
    source: ReportPipelineSourceStatus,
): boolean {
    return !(
        source.sourceStatus === SourceStatus.PENDING &&
        source.procedureStatus === ReportSourceProcedureStatus.PENDING
    );
}

export function isSourceAnalyzingPhaseActive(status: SourceStatus): boolean {
    return (
        status === SourceStatus.PROCESSING ||
        status === SourceStatus.FIXING ||
        status === SourceStatus.QUEUED ||
        status === SourceStatus.UPLOADING
    );
}

function perSourceScore(source: ReportPipelineSourceStatus): number {
    if (
        source.sourceStatus === SourceStatus.ERROR ||
        source.procedureStatus === ReportSourceProcedureStatus.ERROR
    ) {
        return 0;
    }
    if (source.procedureStatus === ReportSourceProcedureStatus.COMPLETED) {
        return 1;
    }
    if (source.procedureStatus === ReportSourceProcedureStatus.PROCESSING) {
        return 0.75;
    }
    if (source.sourceStatus === SourceStatus.COMPLETED) {
        return 0.5;
    }
    if (isSourceAnalyzingPhaseActive(source.sourceStatus)) {
        return 0.25;
    }
    return 0;
}

export function procedureProgressPercent(
    sources: ReportPipelineSourceStatus[],
): number {
    if (sources.length === 0) {
        return 0;
    }
    const total = sources.reduce(
        (sum, source) => sum + perSourceScore(source),
        0,
    );
    return (total / sources.length) * 100;
}
